var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.60156 33.2383H31.3984C34.0986 33.2383 35.8589 31.2046 35.8589 28.7607C35.8589 28.0088 35.6709 27.2568 35.2778 26.5562L21.8623 2.56201C21.0078 1.02393 19.521 0.271973 18 0.271973C16.479 0.271973 14.9751 1.04102 14.1377 2.56201L0.722168 26.5732C0.329102 27.2739 0.124023 28.0088 0.124023 28.7607C0.124023 31.2046 1.90137 33.2383 4.60156 33.2383ZM18.0171 21.3096C16.9233 21.3096 16.3081 20.6943 16.2568 19.6006L16.0005 11.5171C15.9492 10.3721 16.7866 9.56885 18 9.56885C19.1963 9.56885 20.0508 10.3721 19.9995 11.5171L19.7432 19.5835C19.6919 20.7114 19.0767 21.3096 18.0171 21.3096ZM18.0171 27.3081C16.7866 27.3081 15.7783 26.4707 15.7783 25.2744C15.7783 24.0781 16.7695 23.2236 18.0171 23.2236C19.2646 23.2236 20.2388 24.0781 20.2388 25.2744C20.2388 26.4878 19.2476 27.3081 18.0171 27.3081Z",
    fill: "#838AA1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaution);
export default __webpack_public_path__ + "static/media/icon-caution.cbaab8cec00a56b803fbf52fb7abc0a1.svg";
export { ForwardRef as ReactComponent };